var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentajasdetoxMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 253.179,
    height: 43.68,
    viewBox: "0 0 253.179 43.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:#6a841e;}.c{filter:url(#y);}.d{filter:url(#w);}.e{filter:url(#u);}.f{filter:url(#s);}.g{filter:url(#q);}.h{filter:url(#o);}.i{filter:url(#m);}.j{filter:url(#k);}.k{filter:url(#i);}.l{filter:url(#g);}.m{filter:url(#e);}.n{filter:url(#c);}.o{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 4.037,
    width: 33.924,
    height: 35.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 18.218,
    y: 4.037,
    width: 30.43,
    height: 35.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 33.415,
    y: 4.037,
    width: 32.84,
    height: 35.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 50.884,
    y: 4.037,
    width: 31.225,
    height: 35.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 65.62,
    y: 4.037,
    width: 34.039,
    height: 35.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 79.756,
    y: 4.037,
    width: 26.832,
    height: 39.643,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 91.148,
    y: 4.037,
    width: 34.039,
    height: 35.123,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 108.836,
    y: 3.737,
    width: 31.133,
    height: 35.642,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 133.649,
    y: 0.303,
    width: 36.801,
    height: 39.458,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: 156.218,
    y: 0.318,
    width: 33.942,
    height: 39.444,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "t"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "t"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    x: 174.543,
    y: 0.318,
    width: 34.909,
    height: 39.444,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "v"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "v"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    x: 192.65,
    y: 0,
    width: 40.093,
    height: 40.079,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "x"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "x"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "y",
    x: 214.931,
    y: 0.303,
    width: 38.247,
    height: 39.458,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "z"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "z"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-521.778 -598.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(530.778 608.667)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "matrix(1, 0, 0, 1, -9, -9.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M537.3,626.21q-.127-.242-.231-.49c-.069-.165-.138-.336-.208-.513l-6.054-15.162a.412.412,0,0,0-.017-.1.6.6,0,0,1-.017-.156q0-.369.473-.369h2.468a.6.6,0,0,1,.6.439q.254.726.617,1.7t.773,2.064q.41,1.09.842,2.231t.842,2.214q.409,1.073.761,2.012t.594,1.609q.253-.669.6-1.609t.744-2.012q.4-1.072.825-2.214t.83-2.231q.4-1.09.767-2.064t.629-1.7a.612.612,0,0,1,.623-.439h2.421q.519,0,.519.381a.613.613,0,0,1-.018.15.521.521,0,0,0-.017.093l-6.042,15.162q-.092.231-.184.467a4.52,4.52,0,0,1-.208.456.644.644,0,0,1-.427.357,3.019,3.019,0,0,1-.634.058h-1.326a.54.54,0,0,1-.375-.1A.73.73,0,0,1,537.3,626.21Z",
    transform: "translate(-521.78 -599.38)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "matrix(1, 0, 0, 1, -9, -9.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M576.6,609.975q0-.554.507-.554H588.22a.5.5,0,0,1,.427.168.679.679,0,0,1,.127.423v2.037a.542.542,0,0,1-.144.37.549.549,0,0,1-.433.162H580v3.494h6.319a.466.466,0,0,1,.369.1.521.521,0,0,1,.138.41v2.087a.62.62,0,0,1-.115.369.423.423,0,0,1-.369.161H580v4.185h8.5a.512.512,0,0,1,.427.139.717.717,0,0,1,.1.428v2.106q0,.486-.507.486H577.1a.569.569,0,0,1-.357-.115.436.436,0,0,1-.15-.369Z",
    transform: "translate(-549.38 -599.38)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, -9, -9.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M614.818,609.94a.538.538,0,0,1,.133-.369.474.474,0,0,1,.374-.15h2.652a.658.658,0,0,1,.306.075.751.751,0,0,1,.259.236q1.972,2.814,3.909,5.587t3.909,5.587V609.859a.516.516,0,0,1,.173-.323.507.507,0,0,1,.334-.115h2.225a.6.6,0,0,1,.4.139.454.454,0,0,1,.167.369v16.142q0,.473-.542.473h-2.5a.6.6,0,0,1-.472-.312q-2.03-2.94-4.042-5.875t-4.03-5.886v11.565a.531.531,0,0,1-.121.38.549.549,0,0,1-.409.127h-2.214a.5.5,0,0,1-.386-.133.518.518,0,0,1-.121-.363Z",
    transform: "translate(-572.4 -599.38)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, -9, -9.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M658.755,609.929a.476.476,0,0,1,.15-.369.537.537,0,0,1,.381-.139h12.13a.606.606,0,0,1,.375.127.51.51,0,0,1,.19.38v2.018a.612.612,0,0,1-.144.4.518.518,0,0,1-.421.173h-4.382v13.491a.538.538,0,0,1-.144.369.505.505,0,0,1-.4.162h-2.271a.549.549,0,0,1-.375-.15.489.489,0,0,1-.167-.38V612.523h-4.393a.525.525,0,0,1-.381-.144.572.572,0,0,1-.15-.432Z",
    transform: "translate(-598.87 -599.38)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, -9, -9.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M695.826,626.117a3.735,3.735,0,0,1,.132-.427c.05-.13.094-.25.133-.357l6.215-15.474a.687.687,0,0,1,.19-.283.568.568,0,0,1,.421-.156h1.856a.5.5,0,0,1,.4.139,1.494,1.494,0,0,1,.179.242l.381.9,6.088,15.232a.724.724,0,0,0,.017.121.8.8,0,0,1,.017.144q0,.346-.507.346h-2.272a.643.643,0,0,1-.392-.1.76.76,0,0,1-.231-.323l-.208-.53-.438-1.107q-.219-.553-.427-1.118h-7.114q-.3.807-.582,1.516t-.479,1.239a.6.6,0,0,1-.6.427H696.3a.668.668,0,0,1-.352-.081.264.264,0,0,1-.133-.242A.361.361,0,0,1,695.826,626.117Zm8.025-12.3q-.623,1.591-1.239,3.3t-1.239,3.286h4.912Z",
    transform: "translate(-621.2 -599.38)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, -9, -9.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M736.846,609.894a.433.433,0,0,1,.461-.473h2.33a.5.5,0,0,1,.565.554V625.61a8.79,8.79,0,0,1-.1,1.372,4.6,4.6,0,0,1-.554,1.626,4.767,4.767,0,0,1-1.066,1.291,4.98,4.98,0,0,1-1.458.853,4.794,4.794,0,0,1-1.718.311,5.177,5.177,0,0,1-1.885-.346,4.207,4.207,0,0,1-1.551-1.038c-.046-.038-.1-.085-.15-.138s-.108-.11-.161-.167a.953.953,0,0,1-.133-.179.343.343,0,0,1-.052-.162.553.553,0,0,1,.052-.213,1.3,1.3,0,0,1,.138-.242c.058-.081.119-.16.185-.236a1.812,1.812,0,0,1,.19-.2l1.061-.969a.5.5,0,0,1,.167-.1.889.889,0,0,1,.167-.04.5.5,0,0,1,.328.132c.1.088.223.185.357.288a2.672,2.672,0,0,0,.478.288,1.593,1.593,0,0,0,.692.133,1.416,1.416,0,0,0,.6-.139,1.961,1.961,0,0,0,.536-.363,1.815,1.815,0,0,0,.381-.519,1.364,1.364,0,0,0,.144-.605Z",
    transform: "translate(-642.61 -599.38)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, -9, -9.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M760.032,626.117a3.663,3.663,0,0,1,.132-.427c.05-.13.094-.25.132-.357l6.215-15.474a.686.686,0,0,1,.19-.283.568.568,0,0,1,.421-.156h1.856a.5.5,0,0,1,.4.139,1.469,1.469,0,0,1,.179.242l.381.9,6.088,15.232a.726.726,0,0,0,.018.121.794.794,0,0,1,.017.144q0,.346-.507.346H773.28a.643.643,0,0,1-.392-.1.759.759,0,0,1-.231-.323l-.208-.53-.438-1.107q-.219-.553-.427-1.118h-7.114q-.3.807-.583,1.516t-.478,1.239a.6.6,0,0,1-.6.427H760.5a.668.668,0,0,1-.352-.081.264.264,0,0,1-.133-.242A.344.344,0,0,1,760.032,626.117Zm8.025-12.3q-.623,1.591-1.239,3.3t-1.239,3.286h4.912Z",
    transform: "translate(-659.87 -599.38)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -9, -9.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M815.056,613.533a.534.534,0,0,1-.277-.075,2.667,2.667,0,0,1-.288-.2l-.023-.011a6.015,6.015,0,0,0-1.337-.98,5.621,5.621,0,0,0-.917-.392,3.165,3.165,0,0,0-1-.161,4.112,4.112,0,0,0-1.142.144,2.6,2.6,0,0,0-.83.392,1.693,1.693,0,0,0-.508.582,1.538,1.538,0,0,0-.173.715,1.1,1.1,0,0,0,.259.726,2.4,2.4,0,0,0,.7.554,6.9,6.9,0,0,0,1.021.444q.576.2,1.211.4.726.219,1.441.472a13.354,13.354,0,0,1,1.366.571,9.647,9.647,0,0,1,1.217.7,4.6,4.6,0,0,1,.974.888,4.041,4.041,0,0,1,.646,1.119,3.852,3.852,0,0,1,.237,1.389,5.005,5.005,0,0,1-.508,2.271,5.181,5.181,0,0,1-1.4,1.736,6.427,6.427,0,0,1-2.1,1.107,8.444,8.444,0,0,1-2.588.386,7.634,7.634,0,0,1-1.765-.207,8.566,8.566,0,0,1-1.683-.589,8.914,8.914,0,0,1-1.528-.916,7.616,7.616,0,0,1-1.286-1.205v.012l-.023-.046a.841.841,0,0,1-.253-.53.466.466,0,0,1,.069-.243,1.409,1.409,0,0,1,.208-.254l.381-.38q.173-.15.369-.334a5,5,0,0,1,.392-.334q.2-.15.363-.254a.561.561,0,0,1,.271-.1.491.491,0,0,1,.3.1,2.312,2.312,0,0,1,.231.2l.046.047h-.012a7.647,7.647,0,0,0,.9.726,9.088,9.088,0,0,0,1.032.617,6.15,6.15,0,0,0,1.055.427,3.475,3.475,0,0,0,.986.155,4.218,4.218,0,0,0,1.188-.161,3.079,3.079,0,0,0,.957-.455,2.191,2.191,0,0,0,.634-.71,1.867,1.867,0,0,0,.231-.922,1.324,1.324,0,0,0-.3-.87,2.724,2.724,0,0,0-.784-.635,6.008,6.008,0,0,0-1.089-.467q-.605-.2-1.217-.369a18.343,18.343,0,0,1-2.462-.922,7.476,7.476,0,0,1-1.759-1.113,4.131,4.131,0,0,1-1.055-1.384,4.088,4.088,0,0,1-.352-1.724,4.284,4.284,0,0,1,1.66-3.465,5.916,5.916,0,0,1,1.914-.98,8.317,8.317,0,0,1,2.5-.352A7.331,7.331,0,0,1,813.3,609a8.313,8.313,0,0,1,2.006.905q.277.173.565.392t.53.444a3.053,3.053,0,0,1,.4.438.664.664,0,0,1,.156.363.656.656,0,0,1-.069.282,1.078,1.078,0,0,1-.173.259l-.346.369v-.012l-.357.381a4.443,4.443,0,0,1-.369.351q-.184.156-.334.26A.476.476,0,0,1,815.056,613.533Z",
    transform: "translate(-686.67 -598.93)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(664.427 602.64)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 2.29)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, -142.65, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M550.726,688.749a10.661,10.661,0,0,1-.39,2.91,10.388,10.388,0,0,1-1.112,2.57,10.691,10.691,0,0,1-3.949,3.8,11.21,11.21,0,0,1-2.635,1.047,11.594,11.594,0,0,1-2.931.368h-7.119a.914.914,0,0,1-.462-.115.518.518,0,0,1-.2-.491V678.67a.715.715,0,0,1,.166-.491.631.631,0,0,1,.5-.187h7.119a11.3,11.3,0,0,1,2.924.375,11.1,11.1,0,0,1,2.628,1.068,11.268,11.268,0,0,1,2.231,1.661,10.278,10.278,0,0,1,1.726,2.166,10.892,10.892,0,0,1,1.111,2.585A10.488,10.488,0,0,1,550.726,688.749Zm-13.213-5.574v11.1h1.213q.332,0,.65-.022t.635-.05a5.8,5.8,0,0,0,2.022-.527,5.617,5.617,0,0,0,1.639-1.155,5.205,5.205,0,0,0,1.1-1.682,5.5,5.5,0,0,0,.4-2.108,5.412,5.412,0,0,0-.455-2.231,5.487,5.487,0,0,0-3.061-2.917,6.039,6.039,0,0,0-2.231-.412Z",
    transform: "translate(-389.28 -671.69)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, -142.65, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M588.192,678.691a.688.688,0,0,1,.166-.484.6.6,0,0,1,.468-.18h14.326a.639.639,0,0,1,.491.187.715.715,0,0,1,.173.5v3.571a.755.755,0,0,1-.173.468.6.6,0,0,1-.506.223H593.78v3.582H601a.759.759,0,0,1,.455.13.5.5,0,0,1,.18.433v3.12a.6.6,0,0,1-.159.39.57.57,0,0,1-.462.188H593.78v3.7h9.7a.58.58,0,0,1,.65.662v3.628a.358.358,0,0,1-.116.26q-.058.4-.592.4h-14.6a.673.673,0,0,1-.461-.152.593.593,0,0,1-.173-.469Z",
    transform: "translate(-422.97 -671.71)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -142.65, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M633.876,678.66a.586.586,0,0,1,.2-.461.7.7,0,0,1,.484-.172h15.537a.729.729,0,0,1,.462.158.647.647,0,0,1,.231.475v3.585a.81.81,0,0,1-.18.5.607.607,0,0,1-.513.237H645.11v15.812a.686.686,0,0,1-.187.47.626.626,0,0,1-.49.21H640.2a.679.679,0,0,1-.461-.2.627.627,0,0,1-.216-.484V682.98h-4.967a.671.671,0,0,1-.484-.187.724.724,0,0,1-.2-.547Z",
    transform: "translate(-450.33 -671.71)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -142.65, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M679.018,688.3a10.975,10.975,0,0,1,1.5-5.581,11.205,11.205,0,0,1,1.727-2.246,10.792,10.792,0,0,1,2.232-1.726,11.347,11.347,0,0,1,2.637-1.112,11.059,11.059,0,0,1,5.874,0,11.321,11.321,0,0,1,2.644,1.112,10.961,10.961,0,0,1,3.967,3.971,11.459,11.459,0,0,1,1.112,2.643,11.07,11.07,0,0,1,0,5.877,11.183,11.183,0,0,1-1.112,2.628,10.869,10.869,0,0,1-1.727,2.224,11.29,11.29,0,0,1-2.24,1.725,10.9,10.9,0,0,1-2.644,1.112,11.027,11.027,0,0,1-10.743-2.837,11.187,11.187,0,0,1-1.727-2.224,10.78,10.78,0,0,1-1.113-2.628A10.947,10.947,0,0,1,679.018,688.3Zm5.589-.014a6.133,6.133,0,0,0,.4,2.238,5.524,5.524,0,0,0,1.133,1.812,5.275,5.275,0,0,0,1.723,1.213,5.7,5.7,0,0,0,4.391,0,5.254,5.254,0,0,0,1.731-1.213,5.524,5.524,0,0,0,1.132-1.812,6.386,6.386,0,0,0,0-4.47,5.6,5.6,0,0,0-1.132-1.827,5.382,5.382,0,0,0-7.845,0,5.6,5.6,0,0,0-1.133,1.827A6.152,6.152,0,0,0,684.607,688.282Z",
    transform: "translate(-477.37 -671.23)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -142.65, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M734.6,699.074q.115-.217.238-.441a5.29,5.29,0,0,1,.282-.454l6.5-9.7q-1.661-2.5-3.285-4.938t-3.285-4.939a1.377,1.377,0,0,1-.137-.217.648.648,0,0,1-.065-.217.141.141,0,0,1,.166-.108.56.56,0,0,0,.281-.065h5.025a.927.927,0,0,1,.837.549l3.538,5.314,3.581-5.314a.927.927,0,0,1,.837-.549h4.809c.106,0,.2,0,.3.007a.7.7,0,0,1,.238.051.14.14,0,0,1,.1.13.627.627,0,0,1-.159.376l-6.643,9.92,6.772,10.108a2.6,2.6,0,0,1,.224.368.532.532,0,0,1,.065.282q0,.216-.26.216h-5.169a.752.752,0,0,1-.448-.145.974.974,0,0,1-.318-.389L744.69,693.1l-3.884,5.819a.979.979,0,0,1-.318.389.752.752,0,0,1-.447.145h-5.184a.325.325,0,0,1-.2-.065.212.212,0,0,1-.087-.18A.285.285,0,0,1,734.6,699.074Z",
    transform: "translate(-510.64 -671.69)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentajasdetoxMob);
export default __webpack_public_path__ + "static/media/ventajasdetox_mob.d9f78965a3ff7409ec647eecb3d41f97.svg";
export { ForwardRef as ReactComponent };